module.exports = "/packs/004-753ab4dc3f465c903fb3c5474e004b4b.jpg";